export const DISCORD_LINK = "https://discord.gg/rosebud-ai";
